/**
 * Environment detection — derived from REACT_APP_BACKEND_URL at build time.
 *
 * No new env var required; the staging hostname has been stable since the
 * staging environment was provisioned.
 *
 *   isTestEnv() === true   the bundle was built against a staging backend
 *                          (URL contains "cm-staging" or "staging")
 *   isTestEnv() === false  the bundle was built against production (or any
 *                          URL not recognised as staging)
 *
 * Defaulting to PROD (false) on unrecognised URLs is deliberate. A false
 * negative on the banner (no banner on a dev instance) is safer than a
 * false positive (no banner in prod giving false confidence).
 *
 * Optional override (LOCAL DEV ONLY — do NOT document to end users):
 *   REACT_APP_FORCE_TEST_BANNER=1 forces the banner on. Useful for
 *   developers verifying the component renders correctly without having
 *   to point the bundle at staging.
 *
 * Brief 13 (29 May 2026) — V's spec, FE-only, no Azure env var change.
 */
export const isTestEnv = () => {
  if (process.env.REACT_APP_FORCE_TEST_BANNER === "1") return true;
  const url = (process.env.REACT_APP_BACKEND_URL || "").toLowerCase();
  if (!url) return false;
  return url.includes("cm-staging") || url.includes("staging");
};
